const UpdateCard = ({ title, description, icon: Icon }) => {
  return (
    <div className="bg-white rounded-2xl p-8 flex flex-col items-start gap-4 shadow-sm hover:shadow-lg transition-shadow duration-300">
      <div className="w-12 h-12 rounded-full bg-[#6B8F8A] flex items-center justify-center">
        <Icon className="w-6 h-6 text-white" strokeWidth={1.5} />
      </div>
      <h3 className="text-xl font-bold text-[#3a3a3a]">{title}</h3>
      <p className="text-[#6b7280] leading-relaxed">{description}</p>
    </div>
  );
};

export default UpdateCard;
